import * as Moment from 'moment-timezone';

const formatsDate = [
    'M/D/YYYY',
    'MM/DD/YYYY',
    'M/DD/YYYY',
    'MM/D/YYYY',
];

const formatsTime = [
    'h:mm a',
    'h:mma',
    'h a',
    'ha',
    'hmm a',
    'hmma'
];

const dateFormats = formatsDate
    .concat(formatsDate.map(fd => fd.replace(/\//g, ' ')))
    .concat(formatsDate.map(fd => fd.replace(/\//g, '-')));

const formats = formatsTime.reduce((acc, ft) => {
    const formatsSlash = formatsDate.map(fd => `${fd} ${ft}`);
    const formatsDash = formatsDate.map(fd => `${fd.replace(/\//g, ' ')} ${ft}`);
    const formatsSpace = formatsDate.map(fd => `${fd.replace(/\//g, '-')} ${ft}`);
    return acc.concat([
        ...formatsSlash,
        ...formatsDash,
        ...formatsSpace,
    ]);
}, [] as string[]);

export function parseDate(argValue: string, timeZoneName?: string) {
    const value = argValue.replace('m', '');
    let testDate = Moment();
    for (const format of formats) {
        testDate = timeZoneName ? Moment.tz(value, format, true, timeZoneName) : Moment(value, format, true);
        if (testDate.isValid()) {
            return testDate;
        }
    }
    return testDate;
}

export function parseDateOnly(argValue: string) {
    let testDate = Moment();
    for (const format of dateFormats) {
        testDate = Moment(argValue, format, true);
        if (testDate.isValid()) {
            return testDate;
        }
    }
    return testDate;
}


// WEBPACK FOOTER //
// ./src/UtilityFunctions/DateFormat.ts